<template>
  <div>
    <div>{{ value || get(item, field.key) || '-' }}</div>
    <div v-if="subValue" class="text-muted">
      {{ subValue }}
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'

export default {
  name: 'DynamicCell',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    get,
  },
  computed: {
    subValue() {
      if (!this.field.subKey) return null
      return get(this.item, this.field.subKey)
    },
  },
}
</script>
